import { Navigate, Route, Routes } from "react-router";
import HomePage from "./pages/HomePage";
import { AppLayout } from "./layouts/AppLayout";
import PaymentPolicy from "./pages/PaymentPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import NamazAppPrivacyPolicy from "./pages/NamazAppPrivacy";
import DeleteAccount from "./pages/DeleteAccount";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { TourPackages } from "./pages/TourPackages";
import { TourPackageDetails } from "./pages/TourPackageDetails";
import { WhatsappLogin } from "./pages/WhatsappLogin";
import { WhatsappLoginVerify } from "./pages/WhatsappLoginVerify";
import { OrderDetails } from "./pages/OrderDetails";
import { OrderPayments } from "./pages/OrderPatments";


const buildRoute = (route, ...rest) => (
    <Route
        key={route.path}
        path={route.path}
        element={
            route.redirect ? <Navigate to={route.redirect} /> : <route.element />
        }
        {...rest}
    >
        {route?.children && route?.children?.map(buildRoute)}
    </Route>
);

const routes = [
    {
        path: "",
        element: AppLayout,
        children: [
            {
                path: '',
                element: HomePage
            },
            {
                path: 'privacy-policy',
                element: PrivacyPolicy
            },
            {
                path: 'payment-policy',
                element: PaymentPolicy
            },
            {
                path: 'refund-policy',
                element: RefundPolicy
            },
            {
                path: 'namazapp/privacy',
                element: NamazAppPrivacyPolicy
            },
            {
                path: "delete-account",
                element: DeleteAccount
            },
            {
                path: "tourpackages",
                element: TourPackages
            },
            {
                path: "tourpackages/:id",
                element: TourPackageDetails
            },
            {
                path: "orders/:orderID",
                element: OrderDetails
            },
            {
                path: "orders/:orderID/payments",
                element: OrderPayments
            },
            {
                path: 'login/whatsapp/verify',
                element: WhatsappLoginVerify
            },
            {
                path: 'login/whatsapp',
                element: WhatsappLogin
            },

        ],
    },
];


const AppRouter = () => {
    return <Routes>{routes.map(buildRoute)}</Routes>;
};

export default AppRouter;